export const AUTHORIZATION_TOKEN = "authToken";
export const LAST_ACTIVITY = "lastActivity";
export const VERIFIED_EMAIL = "verifiedEmail";
